import { render, staticRenderFns } from "./RoleSelectM.vue?vue&type=template&id=56c798a6&scoped=true&"
import script from "./RoleSelectM.vue?vue&type=script&lang=ts&"
export * from "./RoleSelectM.vue?vue&type=script&lang=ts&"
import style0 from "./RoleSelectM.vue?vue&type=style&index=0&id=56c798a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c798a6",
  null
  
)

export default component.exports